import InnerBanner from "../Components/InnerBanner/InnerBanner";
import {Link} from "react-router-dom";

function Contact() {
    return (
        <>
            <InnerBanner
                img_url='contactBanner.webp'
                heading={['We are here to help you. If you have', <br/>, 'any question, Let us now!']}
            />
            <section className="contactSec">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="questionnaire">
                                <div className="title">
                                    <h2 className="secHeading" data-aos='fade-up'>
                                        Have Any Questions?
                                    </h2>
                                    <p data-aos='fade-up' data-aos-delay='100'>
                                        Have a inquiry or some feedback for us? Fill out the form below to contact our
                                        team.
                                    </p>
                                </div>
                                <ul className="info">
                                    <li>
                                        <Link to="">
                                            <span className="icon">
                                                <i className="fas fa-map-pin"/>
                                            </span>
                                            <span className="details">
                                                <strong>
                                                    Our Address
                                                </strong>
                                                <span>
                                                    124 City Road, London, EC1V 2NX
                                                </span>
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="">
                                            <span className="icon">
                                                <i className="fas fa-phone-alt"/>
                                            </span>
                                            <span className="details">
                                                <strong>
                                                    Support 24/7
                                                </strong>
                                                <span>
                                                    +61 (0) 345 876 654
                                                </span>
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="mailto:info@skilbridge.com">
                                            <span className="icon">
                                                <i className="fas fa-envelope"/>
                                            </span>
                                            <span className="details">
                                                <strong>
                                                    Email
                                                </strong>
                                                <span>
                                                    Sales@skilbridge.com
                                                    <br/>
                                                    info@skilbridge.com
                                                </span>
                                            </span>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="contactForm">
                                <div className="head">
                                    <h5 data-aos='fade-up'>Contact Us</h5>
                                    <h3 data-aos='fade-up' data-aos-delay='100'>
                                        Get in Touch
                                    </h3>
                                    <p data-aos='fade-up' data-aos-delay='150'>
                                        At Skill Bridge, we value your feedback, inquiries, and comments. Whether you
                                        have a quesMon about our products or services, need assistance, or simply want
                                        to say hello, we're just a message away. Feel free to get in touch with us using
                                        the opMons below.
                                    </p>
                                </div>
                                <form action="" className=''>
                                    <input type="text" placeholder='First Name'/>
                                    <input type="text" placeholder='Last Name'/>
                                    <input type="email" placeholder='Email Address'/>
                                    <input type="tel" placeholder='Phone Number'/>
                                    <textarea name="" id="" rows="10" placeholder='Write your message'/>
                                    <button className="themeBtn">Send Message</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact